import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[emsAccountNumberFormat]'
})
export class AccountNumberFormatDirective {

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInput(event: any) {
  const input = event.target;
  const oldVal = input.value;
  const cursorPosition = input.selectionStart || 0;
  const isAtEnd = cursorPosition === oldVal.length;
  const formattedVal = this.formatAccountNumber(oldVal);
  
  if (oldVal !== formattedVal) {
    input.value = formattedVal;
    
    // Smart cursor positioning with minimal code
    const newPos = isAtEnd ? 
      formattedVal.length : 
      (cursorPosition <= 4 ? cursorPosition : cursorPosition + (formattedVal.length - oldVal.length));
    
    // Use requestAnimationFrame instead of setTimeout for better performance
    requestAnimationFrame(() => {
      if (document.activeElement === input) {
        input.setSelectionRange(newPos, newPos);
      }
    });
  }
}

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();


    const pastedValue = event.clipboardData?.getData('text') || '';
    const input = event.target as HTMLInputElement;

    // Remove all non-digits
    const digitsOnly = pastedValue.replace(/\D/g, '');

    // Limit to maximum 9 digits
    const limitedDigits = digitsOnly.substring(0, 9);

    // Format with dash
    const formattedValue = this.formatAccountNumber(limitedDigits);

    // Update input value
    input.value = formattedValue;

    setTimeout(() => {
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    const key = event.key;
    
    // Allow navigation and control keys
    const allowedKeys = [
      'Backspace', 'Delete', 'Tab', 'Enter', 'Home', 'End', 
      'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'
    ];
    
    // Allow Ctrl combinations
    if (event.ctrlKey && ['a', 'c', 'v', 'x', 'z'].includes(key.toLowerCase())) {
      return;
    }
    
    // Allow navigation keys
    if (allowedKeys.includes(key)) {
      return;
    }
    
    // Only allow digits
    if (!/^\d$/.test(key)) {
      event.preventDefault();
    }
  }

  private formatAccountNumber(value: string): string {
    if (!value) 
      return '';
    
    const accountNumWithNoDash = value.replace(/\D/g, '');
    // Format with dash after 4 digits if more than 4 digits
    if (accountNumWithNoDash.length <= 4) {
      return accountNumWithNoDash;
    }
    return `${accountNumWithNoDash.substring(0, 4)}-${accountNumWithNoDash.substring(4)}`;
  }
}